import React from 'react';
import { 
  MultiSelect, 
  MultiSelectChangeEvent
} from '@progress/kendo-react-dropdowns';
import { diffArray } from '../../utility/Util';
import * as _ from 'lodash';
import { 
  MultiSelectProps
} from '@progress/kendo-react-dropdowns/dist/npm/MultiSelect/MultiSelectProps';
import { MULTISELECT_PROPS } from './Types';

function withValueField(WrappedComponent: React.ForwardRefExoticComponent<MultiSelectProps & React.RefAttributes<any>>) {
  return class extends React.Component<MULTISELECT_PROPS> {
    handleChange = (event: MultiSelectChangeEvent) => {
      const previousValue = event.target.props.value;
      const currentValue = event.target.value;
      let lastModified = diffArray(currentValue, previousValue);
      if (_.isEmpty(lastModified)) {
        lastModified = diffArray(previousValue, currentValue);
        lastModified = lastModified.map((item: any) => {
          item.isDeleted = true;
          return item;
        });
      }
      this.props.onChange({ 
        ...event, 
        lastModified, 
        currentValue, 
        previousValue
      });
    };

    render() {
      return (
        <WrappedComponent {...this.props} onChange={this.handleChange} />
      );
    }
  };
}

const Multiselect = withValueField(MultiSelect);
export default Multiselect;
